import React, { useState, useEffect } from 'react';
import { parseCoordinate } from '../../utils/parseCoordinate';

interface RangedInputProps {
  min: number;
  max: number;
  reason: string;
  inputType: string;
  placeholder: string;
  defaultValue: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function RangedInput({
  min,
  max,
  reason,
  inputType,
  placeholder,
  defaultValue,
  onChange
}: RangedInputProps) {
  const [value, setValue] = useState<string>("");

  useEffect(() => {
    if (!value && defaultValue) {
      setValue(defaultValue);
    }
  }, [defaultValue]);
  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const newValue = e.target.value;
  setValue(newValue);

  const decimal = parseCoordinate(newValue);

  if (decimal !== null && decimal >= min && decimal <= max) {
    // Create a new synthetic event with decimal value for Redux
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: decimal.toString(),
      },
    } as React.ChangeEvent<HTMLInputElement>;

    onChange(syntheticEvent);
  }
};


  const decimal = parseCoordinate(value);
  const isOutOfRange = decimal === null || decimal < min || decimal > max;

  return (
    <>
      <input
        className='lat-lon-input'
        type={inputType}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        style={{
          borderColor: isOutOfRange ? 'red' : 'green',
          borderWidth: '2px',
          padding: '5px',
          borderRadius: '4px',
          outline: 'none',
        }}
      />
      <p className='lat-lon-p'>
        {isOutOfRange && reason && (
          <span style={{ color: 'red' }}>{reason}</span>
        )}
      </p>
    </>
  );
}
